const messages = {};
import kr from 'babel-loader!./lang/kr';
messages['kr'] = kr;
export default messages;

if (module.hot) {
  module.hot.accept(
    ["babel-loader!./lang/kr"],
    function(requests) {
      requests.forEach(request => {
        var locale = request.replace(/.*\/(\w+)\.js$/, '$1');
        vue.$i18n.setLocaleMessage(locale, __webpack_require__(request).default);
      });
    }
  );
}
  